export const environment = {
    production: false,
    staging: true,
    frontendUrl: 'https://horizonnet-staging.web.app',
    apiUrl: 'https://us-central1-horizonnet-staging.cloudfunctions.net/api',
    stripePublishableKey: 'pk_test_51Qh8EAGmKQzZmpXRWnyWScYgNZPTmnDJrJ1c2VmMIGU7o62WdWHt3rIt4Yn2Ob0VL0fip3QOmaiyoJ9Tqo7Ge3Qf00bQIyVqEe',
    supportEmail: 'dev@horizonnet-consulting.at',
    visitorChatEmail: 'dev@horizonnet-consulting.at',
    firebase: {
      apiKey: "AIzaSyCIIszC83jgBnjwohfsl8JOag9W3aYiJzE",
      authDomain: "horizonnet-staging.firebaseapp.com",
      projectId: "horizonnet-staging",
      storageBucket: "horizonnet-staging.firebasestorage.app",
      messagingSenderId: "1042207165710",
      appId: "1:1042207165710:web:a7f0b9adedb69cab689b5f",
      measurementId: "G-XXXXXXXXXX", // We'll need to set this up in Google Analytics
      FIREBASE_PROJECT_ID: "horizonnet-staging",
      FIREBASE_STORAGE_BUCKET: "horizonnet-staging.firebasestorage.app"
    }
  }; 